import { render, staticRenderFns } from "./departEvaluation.vue?vue&type=template&id=6920e5ea&scoped=true&"
import script from "./departEvaluation.vue?vue&type=script&lang=js&"
export * from "./departEvaluation.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/evaluation/evaluation.less?vue&type=style&index=0&id=6920e5ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920e5ea",
  null
  
)

component.options.__file = "departEvaluation.vue"
export default component.exports